import React, { FC } from 'react'

const FireIcon: FC = () => (
  <svg width="30" height="36" viewBox="0 0 30 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.499344 17.5693C0.499344 17.5693 1.95289 19.6008 4.9994 21.3203C4.9994 21.3203 2.79299 3.58089 17.1692 0.5C13.4859 13.3598 21.8544 16.9865 24.9048 10.1924C29.9991 16.6627 26.1312 22.3077 26.1312 22.3077C28.22 22.594 29.9746 20.423 29.9746 20.423C29.9903 20.6904 29.9991 20.9597 29.9991 21.2309C29.9991 29.1115 23.2836 35.5 14.9996 35.5C6.71553 35.5 0 29.1115 0 21.2308C0 19.9649 0.174185 18.7379 0.499344 17.5693Z"
      fill="#FF6536"
    />
    <path
      d="M29.9751 20.423C29.9751 20.423 28.2205 22.594 26.1317 22.3077C26.1317 22.3077 29.9996 16.6627 24.9053 10.1924C21.8549 16.9865 13.4864 13.3598 17.1697 0.5C16.3997 0.66502 15.6777 0.872353 15 1.11646V35.5C23.284 35.5 29.9996 29.1115 29.9996 21.2308C29.9996 20.9596 29.9908 20.6904 29.9751 20.423Z"
      fill="#FF421D"
    />
    <path
      d="M8.42188 29.242C8.42188 32.6981 11.3671 35.4999 15.0001 35.4999C18.6331 35.4999 21.5783 32.6981 21.5783 29.242C21.5783 27.3921 20.7346 25.7298 19.3932 24.5841C16.8499 27.8712 13.2255 22.885 16.0501 19.2438C16.0501 19.2438 8.42188 20.1532 8.42188 29.242Z"
      fill="#FBBF00"
    />
    <path
      d="M21.5782 29.242C21.5782 27.3921 20.7345 25.7298 19.3931 24.5841C16.8498 27.8712 13.2254 22.885 16.05 19.2438C16.05 19.2438 15.6355 19.2933 15 19.4841V35.4999C18.633 35.4999 21.5782 32.6981 21.5782 29.242Z"
      fill="#FFA900"
    />
  </svg>
)

export default FireIcon
